import { useEffect, useMemo } from 'react';

import { useDatasetStore } from '@/stores/database/aliases/datasets/store';
import { ReportComponentType } from '@/types';
import { DataSourceType } from '@/types/api/modules/business-intelligence';

import {
    createGlobalTradeDatasetQuery,
    GLOBAL_TRADE_DATASET_ID,
    globalTradeRowsToMapData,
    GlobalTradeViewDefinition,
} from './model';

export const useGlobalTradeData = (queryStateKey: string, view: GlobalTradeViewDefinition) => {
    const queryDatasets = useDatasetStore((state) => state.queryDatasets);
    const queryState = useDatasetStore((state) => state.componentQueryState[queryStateKey]);
    const requestKey = JSON.stringify(createGlobalTradeDatasetQuery(view));
    const configuration = useMemo(
        () => ({
            data: JSON.parse(requestKey) as ReturnType<typeof createGlobalTradeDatasetQuery>,
            dataSet: {
                key: GLOBAL_TRADE_DATASET_ID,
                type: DataSourceType.GLOBAL_TRADE,
            },
            type: ReportComponentType.GLOBE,
            version: 1,
        }),
        [requestKey],
    );

    useEffect(() => {
        void queryDatasets(queryStateKey, configuration, requestKey);
    }, [configuration, queryDatasets, queryStateKey, requestKey]);

    const currentData = queryState?.requestKey === requestKey ? queryState.data : undefined;
    const mapData = useMemo(() => globalTradeRowsToMapData(currentData?.rows ?? []), [currentData?.rows]);

    return {
        ...mapData,
        error: queryState?.requestKey === requestKey ? queryState.error : undefined,
        loading: queryState?.requestKey === requestKey ? queryState.loading : true,
    };
};
